import {useMemo} from 'react'
import {useWindowSize, media} from '@components/lib'

const getValue = key => {
  const {breakpoints} = media
  return typeof key === 'number' ? key : breakpoints[key] ?? key
}

const useNavCollapsed = breakpoint => {
  const size = useWindowSize()

  const isCollapsedDown = useMemo(
    () => size.width < getValue(breakpoint),
    // eslint-disable-next-line
    [size]
  )

  const isCollapsedUp = useMemo(
    () => size.width > getValue(breakpoint),
    // eslint-disable-next-line
    [size]
  )

  return {isCollapsedDown, isCollapsedUp}
}

export default useNavCollapsed
